export default __webpack_public_path__ + "static/media/twitter.b2838bf8.svg";